exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nhFUVZqO2_ctf4BWt7bR5{fill:var(--neutralPrimary)}._1KLvfpUxH_oUXjvknjFf96{cursor:pointer!important}.apcBYu6oSkNpiegESlgbN{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"icon": "nhFUVZqO2_ctf4BWt7bR5",
	"card": "_1KLvfpUxH_oUXjvknjFf96",
	"image": "apcBYu6oSkNpiegESlgbN"
};